import { useEffect, useState } from "react";
import { Form, Input, Modal, Spin, message } from "antd";
import { useUserContext } from "../context/dashboard-context";
import PartnersCard from "../components/product-card/partners-card";
import CustomPagination from "../components/pagination";
import PartnersImageUploader from "../components/imageUploader/PartnersImageUploader";
import api from "../context/api";
import "./brends.scss";

const PartnersPage = () => {
  const [loading, setLoading] = useState(true); // Initialize as true
  const { token, brands, setBrands, totalProducts, setTotalProducts } = useUserContext();
  const [value, setValue] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [imageUrl, setImageUrl] = useState("");
  const [form] = Form.useForm();

  const fetchBrands = async (page = 1) => {
    setLoading(true);
    try {
      const response = await api.get(`/partner/?page=${page}`);
      console.log("API Response:", response.data);
      
      // Ensure we always set an array
      const brandsData = Array.isArray(response.data) 
        ? response.data 
        : response.data?.data || [];
      
      setBrands(brandsData);
      
      // Handle total count carefully
      if (response.data?.totalCount !== undefined) {
        setTotalProducts(response.data.totalCount);
      } else if (response.data?.count !== undefined) {
        setTotalProducts(response.data.count);
      }
    } catch (error) {
      console.error("Error fetching brands:", error);
      setBrands([]); // Reset to empty array on error
    } finally {
      setLoading(false);
    }
  };

  // Fetch brands on mount and page change
  useEffect(() => {
    fetchBrands(currentPage);
  }, [currentPage]);

  // Debugging effect
  useEffect(() => {
    console.log("Current brands:", brands);
    console.log("Loading state:", loading);
  }, [brands, loading]);

  const AddBrand = async () => {
    if (!imageUrl) {
      message.error("Iltimos, rasm yuklang");
      return;
    }
  
    setLoading(true);
    const formData = new FormData();
    formData.append("name", value);
    
    if (imageUrl instanceof File || imageUrl instanceof Blob) {
      formData.append("image_url", imageUrl);
    } else if (typeof imageUrl === 'string') {
      formData.append("image_url", imageUrl);
    }
  
    try {
      const response = await api.post("/partner/", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
  
      if ([200, 201].includes(response.status)) {
        message.success("Brand muvaffaqiyatli qo'shildi");
        await fetchBrands(currentPage); // Wait for refresh
        form.resetFields();
        setImageUrl("");
        setIsModalOpen(false);
      }
    } catch (error) {
      console.error("Error adding brand:", error);
      message.error(error.response?.data?.message || "Brand qo'shilmadi");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="brends-page">
      <div className="page-top">
        <h1>Partnerlar</h1>
        <button onClick={() => setIsModalOpen(true)}>+ Partner qo'shish</button>
      </div>
      
      <div className="page-cards">
        {loading ? (
          <Spin size="large" />
        ) : brands?.length > 0 ? (
          brands.map((brand) => (
            <PartnersCard 
              key={brand.id} 
              data={brand} 
              handleRefetch={() => fetchBrands(currentPage)} 
            />
          ))
        ) : (
          <p>Hech qanday partner topilmadi</p>
        )}
      </div>

      {!loading && brands?.length > 0 && (
        <CustomPagination
          current={currentPage}
          total={totalProducts}
          onChange={(page) => {
            setCurrentPage(page);
          }}
        />
      )}

      <Modal
        title="Brend qo'shish"
        open={isModalOpen}
        onCancel={() => {
          setIsModalOpen(false);
          setImageUrl("");
          form.resetFields();
        }}
        footer={null}
      >
        <Spin spinning={loading}>
          <Form form={form} onFinish={AddBrand}>
            <PartnersImageUploader
              image_url={imageUrl}
              setImageUrl={setImageUrl}
            />
            <Form.Item
              label="Nomi"
              name="name"
              rules={[{ required: true, message: "Nomi kiritilishi shart" }]}
            >
              <Input
                placeholder="Nomi"
                onChange={(e) => setValue(e.target.value)}
              />
            </Form.Item>
            <div className="modal-footer">
              <button type="button" onClick={() => setIsModalOpen(false)}>
                Bekor qilish
              </button>
              <button type="submit" style={{ color: "white" }}>
                Qo'shish
              </button>
            </div>
          </Form>
        </Spin>
      </Modal>
    </div>
  );
};

export default PartnersPage;